import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

// Добавляет Bearer-токен Keycloak к каждому HTTP-запросу.
// При 401 — разлогинивает (Keycloak сам сделает редирект на страницу входа).
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(AuthService);

    const token = auth.getToken();

    // Клонируем запрос с токеном (оригинал иммутабелен)
    const authReq = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && !auth.initializing) {
                auth.logout();
            }
            return throwError(() => error);
        })
    );
};